import ctx from '../../plugins/axios';

// eslint-disable-next-line import/no-anonymous-default-export
export default async (specialityListObj) => {
  return await ctx.put(
    `/specialty_list/${specialityListObj.UUID}`,
    specialityListObj.updatedList
  );
};
